export default function validateForm(formValues, requiredFields) {
  const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

  for (const field of requiredFields) {
    const key = Object.keys(formValues).find(k => k.includes(field));
    const value = formValues[key];

    if (value === undefined || value === null || value === "") {
      return false;
    }

    if (field === "customer-email" && !emailRegex.test(value)) {
      return false;
    }
  }

  return true;
}